import React from "react";

function EmptyState({ icon: Icon, title, description,buttonText, buttonLink }) {
  return (
    <div className="overflow-hidden rounded-lg bg-white shadow-sm mt-3 text-center">
      <div className="p-6">
        {Icon && <Icon className="mx-auto size-12 text-gray-400" aria-hidden="true" />}
        <h3 className="mt-2 text-sm font-semibold text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-500">{description}</p>
        <br/>
         {buttonText && buttonLink && (
          <a
            href={buttonLink}
            className="btn-main mt-4"
          >
            {buttonText}
          </a>
        )}
      </div>
    </div>
  );
}

export default EmptyState;